import { Link, useLocation } from "react-router-dom";
import usePageMeta from "@/hooks/usePageMeta";

export default function NotFound() {
  const location = useLocation();

  usePageMeta({
    title: "页面不存在 - 黑料吃瓜网",
    description: "你访问的页面不存在或已被移除，可以返回首页继续浏览娱乐八卦资讯。",
    keywords: "黑料吃瓜网,404",
  });

  return (
    <div className="w-full max-w-[820px] mx-auto px-4 md:px-6 py-16 md:py-24 text-center">
      <p className="font-heading text-[80px] md:text-[120px] leading-none font-bold text-background-300 select-none">
        404
      </p>
      <h1 className="mt-2 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
        这个瓜没找到
      </h1>
      <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
        页面可能已经被移动或删除。你访问的地址是：
        <span className="ml-1 text-foreground-800 break-all">{location.pathname}</span>
      </p>
      <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-1.5 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
        >
          <i className="ri-home-4-line" />
          返回首页
        </Link>
        <Link
          to="/category/entertainment"
          className="inline-flex items-center gap-1.5 px-5 py-2.5 rounded-md border border-background-300 text-foreground-700 text-sm whitespace-nowrap hover:bg-background-50 transition-colors cursor-pointer"
        >
          浏览娱乐新闻
        </Link>
        <Link
          to="/search"
          className="inline-flex items-center gap-1.5 px-5 py-2.5 rounded-md border border-background-300 text-foreground-700 text-sm whitespace-nowrap hover:bg-background-50 transition-colors cursor-pointer"
        >
          <i className="ri-search-line" />
          站内搜索
        </Link>
      </div>
    </div>
  );
}